import merge from 'deepmerge';

export const initialState = {
  uiAccount: {
    dialogState: null,
    offset: 0,
    uiAddForm: {
      loading: false,
      selectLoading: false,
    },
    uiEditForm: {
      loading: false,
      data: {
        AccountName: '',
        DisplayName: '',
        Password: '',
        AssociatedDevice: '',
        DeviceDisplayName: '',
      },
    },
    uiTable: { loading: true },
  },
  uiDevice: {
    dialogState: null,
    dataIndex: null,
    offset: 0,
    uiTable: { loading: true },
    uiForm: { loading: false },
  },
  uiHome: {
    uiMenuSider: { uiMenu: { selectedKeys: ['device'] } },
    uiFormPassword: { loading: false },
  },
  uiIndex: {
    uiHeader: {
      uiMenuUser: {
        dialogState: null,
        uiFormSetting: { loading: false },
        uiFormPassword: { loading: false },
      },
      uiMenuNotice: {
        dialogState: false,
      },
    },
  },
  uiResetPwd: {
    uiForm: { loading: false },
  },
  uiLogin: {
    cookieVisibility: true,
    uiForm: {
      cookieEnable: false,
      cookieEditable: false,
    },
  },
  uiCreateNewAccount: {
    uiForm: {
      variCounter: 0,
      loading: false,
      acceptTerm: false,
    },
  },
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UI_UPDATE':
      return merge(state, action.payload, {
        arrayMerge: (target, source) => source,
      });
    default:
      return state;
  }
};

export default uiReducer;
